import script from "./AnnualQuestionnaireDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnualQuestionnaireDialog.vue?vue&type=script&setup=true&lang=js"

import "./AnnualQuestionnaireDialog.vue?vue&type=style&index=0&id=40478eae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40478eae"]])

export default __exports__